/* eslint-disable no-unused-vars */
export enum ConfigurationActionTypes {
    SetHeaderOffsetHeight = 'SET_HEADER_OFFSET_HEIGHT',
    SetConfiguration = 'SET_CONFIGURATION',
    SetResDragModalZIndex = 'SET_RES_DRAG_MODAL_ZINDEX'
}

export type ReducerAction = {
    type: ConfigurationActionTypes;
    payload?: unknown;
};
